import { X } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { embedUrl, isEmbedUrl } from "@/components/layers";
import { QuizRunner } from "@/components/player/QuizRunner";

export const MediaModal = ({ modal, onClose, onQuizComplete }) => {
  if (!modal) return null;
  const { kind, layer } = modal;
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-[#0F172A]/30 p-4 backdrop-blur-md" onClick={onClose} data-testid="player-modal" role="dialog" aria-modal="true" aria-label={layer.title || layer.name}>
      <div className="relative max-h-[90vh] w-full max-w-3xl overflow-auto rounded-3xl neu-panel anim-scale" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} aria-label="Close" data-testid="player-modal-close" className="absolute right-3 top-3 z-10 neu-circle p-2 text-[#0F172A]"><X className="h-4 w-4" /></button>
        {kind === "video" && <VideoBody layer={layer} />}
        {kind === "image" && <img src={fileUrl(layer.src)} alt={layer.alt || layer.name} className="max-h-[85vh] w-full object-contain" />}
        {kind === "quiz" && <QuizRunner layer={layer} onComplete={onQuizComplete && ((r) => onQuizComplete(layer, r))} />}
        {kind === "popup" && (
          <div className="p-8">
            {layer.src && <img src={fileUrl(layer.src)} alt="" className="mb-5 max-h-72 w-full rounded object-cover" />}
            <h3 className="font-display text-2xl font-extrabold tracking-tight" data-testid="player-popup-title">{layer.title}</h3>
            <p className="mt-3 whitespace-pre-wrap text-sm leading-relaxed text-[#334155]" data-testid="player-popup-content">{layer.content}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export const VideoBody = ({ layer, inline }) => {
  if (!layer.src) return <div className="grid aspect-video place-items-center bg-black text-sm text-[#64748B]">No video source set</div>;
  if (isEmbedUrl(layer.src)) return <iframe src={embedUrl(layer.src)} title={layer.alt || layer.name} className={inline ? "h-full w-full" : "aspect-video w-full"} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />;
  const src = fileUrl(layer.src) + (layer.start || layer.end ? `#t=${layer.start || 0}${layer.end ? `,${layer.end}` : ""}` : "");
  return (
    <video src={src} poster={fileUrl(layer.poster)} autoPlay playsInline muted={inline && layer.muted && layer.autoplay} loop={layer.loop} controls={layer.controls !== false} preload="metadata" className={inline ? "h-full w-full bg-black object-contain" : "aspect-video w-full bg-black"} data-testid="player-video" />
  );
};
